import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  createWhatsAppAction,
  updateWhatsAppAction,
} from "../../Actions/WhatsAppAction/WhatsAppAction";
import { udpateUndergoneSurgeryAction } from "../../Actions/UndergoneSurgeryAction/UndergoneSurgeryAction";
import Input from "../../Buttons/Input";
import { getHospitalAction } from "../../Actions/HospitalAction/HospitalAction";

const WhatsAppPage = ({ visit, visitId, branchId, patientId, closeModal }) => {
  const [doctorName, setDoctorName] = useState(null);
  const [surgeryName, setSurgeryName] = useState(null);

  const dispatch = useDispatch();
  const [state, setState] = useState({
    id: "",
    patient: "",
    zad: "",
    hospital: "",
    doctor: "",
    totalOfSurgery: "",
    date: "",
    nameOfHospital: "",
  });
  const createWhatsApp = useSelector((state) => state.createWhatsApp);
  const { error, whatsApps } = createWhatsApp;
  const formatNumber = (num) => {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/,/g, "");

    if (!isNaN(numericValue) && /^\d*$/.test(numericValue)) {
      const formattedValue = formatNumber(numericValue);
      const newState = {
        ...state,
        [name]: formattedValue,
      };

      const total = ["patient", "zad", "hospital", "doctor"]
        .map((key) => parseInt((newState[key] || "0").replace(/,/g, "")) || 0)
        .reduce((sum, val) => sum + val, 0);

      setState({
        ...newState,
        totalOfSurgery: formatNumber(total.toString()),
      });
    }
  };

  useEffect(() => {


    if (!visit) {
      return null;
    }

    else if (visit?.whatsApp?.id) {
      setState({
        id: visit?.whatsApp?.id || "",
        patient: visit?.whatsApp?.patient || "",
        zad: visit?.whatsApp?.zad || "",
        hospital: visit?.whatsApp?.hospital || "",
        doctor: visit?.whatsApp?.doctor || "",
        totalOfSurgery: visit?.whatsApp?.total_of_surgery || "",
        date: visit?.whatsApp?.date || "",
        nameOfHospital:
          {
            label: visit?.whatsApp?.hospital_relation?.name,
            value: visit?.whatsApp?.hospital_relation?.id,
          } || "",
      });
    }
    else {
      setState({
        id: "",
        patient: "",
        zad: "",
        hospital: "",
        doctor: "",
        totalOfSurgery: "",
        date: "",
        nameOfHospital: "",
      });
    }

  }, [visit?.whatsApp, dispatch]);
  // console.log(state?.nameOfHospital);
  useEffect(() => {
    if (!visit) {
      return null;
    }
    if (visit.follow_up_commite.length == 0) {
      setDoctorName("");
      return;
    } else if (visit.follow_up_commite) {
      if (visit?.follow_up_commite[0]) {
        setDoctorName(
          visit?.follow_up_commite[0].doctor.map((doctor) => doctor).join(",")
        );

        setSurgeryName(
          visit?.follow_up_commite[0].organ_level
            .map((organ_level) => organ_level)
            .join(",")
        );
      }
      return;
    } else {
      setDoctorName(null);
      return null;
    }
  }, [visitId, visit]);
  const [errorMessage, setErrorMessage] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();

    if (
      branchId == undefined ||
      branchId == null ||
      branchId == "" ||
      branchId == 0
    ) {
      setErrorMessage("Please Select Branch");
      return;
    }

    // console.log(state.nameOfHospital.value)
    // return
    closeModal();
    dispatch(
      udpateUndergoneSurgeryAction(
        visit?.undergone_surgery_or_suplies?.id,
        visitId,
        1,
        0,
        state.date
      )
    );
    if (visit?.whatsApp?.id) {
      dispatch(
        updateWhatsAppAction(
          whatsApps?.id || visit?.whatsApp?.id,
          visitId,
          branchId,
          state.patient,
          state.zad,
          state.hospital,
          state.doctor,
          state.totalOfSurgery,
          state.date,
          state.nameOfHospital,
          patientId
        )
      );
    } else {
      dispatch(
        createWhatsAppAction(
          visitId,
          branchId,
          state.patient,
          state.zad,
          state.hospital,
          state.doctor,
          state.totalOfSurgery,
          state.date,
          state.nameOfHospital,
          patientId
        )
      );
    }
  };

  useEffect(() => {
    dispatch(getHospitalAction(0, 5000, ""));
  }, []);
  const { hospitals, total } = useSelector((state) => state.getHospital);

  const hospitalList = hospitals?.map((hospital) => ({
    value: hospital.id,
    label: hospital.name + " - " + hospital.branch.name,
  }));

  return (
    <>
      <div>
        <div className="bg-teal-500 rounded-sm shadow-md md:w-5/12 lg:w-2/12 text-white m-auto p-2 text-center mt-3">
          زانیاری نەشتەرگەری
        </div>
        {errorMessage && (
          <div
            className="bg-red-100 border my-4 border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <span className="block sm:inline">{errorMessage}</span>
            <span
              className="absolute top-0 bottom-0 right-0 px-4 py-3"
              onClick={() => setErrorMessage("")}
            >
              <svg
                className="fill-current h-6 w-6 text-red-500"
                role="button"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        )}

        <form action="" className="my-2">
          <div className="grid  lg:grid-cols-3 gap-3">
            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Patient Name</label>
              </div>
              <input
                type="text"
                value={visit.patient.patient_info.fullname}
                className="input p-1"
                placeholder="Patient Name"
              />
            </div>
            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Doctor Name</label>
              </div>
              <input
                type="text"
                value={doctorName || ""}
                className="input p-1"
                placeholder="Doctor Name"
              />
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Surgery Name</label>
              </div>
              <input
                type="text"
                value={surgeryName || ""}
                className="input p-1"
                placeholder="Surgery Name"
              />
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Patient </label>
              </div>
              <input
                className="input p-1"
                type="text"
                name="patient"
                value={state.patient || ""}
                onChange={handleChange}
                placeholder="Patient"
              />
              <p className="text-red-500 ">{error && error.patient}</p>
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Zad </label>
              </div>
              <input
                type="text"
                className="input p-1"
                name="zad"
                value={state.zad || ""}
                onChange={handleChange}
                placeholder="Zad"
              />
              <p className="text-red-500 ">{error && error.zad}</p>
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Hospital </label>
              </div>
              <input
                type="text"
                className="input p-1"
                name="hospital"
                value={state.hospital || ""}
                onChange={handleChange}
                placeholder="Hospital"
              />
              <p className="text-red-500 ">{error && error.hospital}</p>
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Doctor </label>
              </div>
              <input
                type="text"
                className="input p-1"
                name="doctor"
                value={state.doctor || ""}
                onChange={handleChange}
                placeholder="Doctor"
              />
              <p className="text-red-500 ">{error && error.doctor}</p>
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Total Of Surgery </label>
              </div>
              <input
                type="text"
                value={state.totalOfSurgery || ""}
                disabled
                className="input p-1"
                placeholder="Total Of Surgery"
              />
              <p className="text-red-500 ">{error && error.total_of_surgery}</p>
            </div>

            <div className="flex flex-col gap-1">
              <Input
                type={"select"}
                options={hospitalList}
                name={"nameOfHospital"}
                label={" Name Hospital"}
                placeholder={"Hospital"}
                setFormData={setState}
                formData={state}
              />

              <p className="text-red-500 ">{error && error.name_of_hospital}</p>
            </div>

            <div className="flex flex-col gap-1">
              <div>
                <label htmlFor="">Date </label>
              </div>
              <input
                type="date"
                value={state.date || ""}
                name="date"
                onChange={(e) => setState({ ...state, date: e.target.value })}
                className="input p-1"
                placeholder="Doctor "
              />

              <p className="text-red-500 ">{error && error.date}</p>
            </div>
          </div>
          <button
            onClick={(e) => handleSubmit(e)}
            className="btn-info flex gap-2 items-center mt-2"
          >
            Send <IoMdSend />
          </button>
        </form>
      </div>
    </>
  );
};

export default WhatsAppPage;
